import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import TravelCard from '../components/TravelCard';
import AdvertisingBanner from '../components/AdvertisingBanner';
import SoldSection from '../components/SoldSection';
import AirlinesSection from '../components/AirlinesSection';
import BestPriceSection from '../components/BestPriceSection';
import EuropeSection from '../components/EuropeSection';
import InspirationSection from '../components/InspirationSection';
import NewsletterSection from '../components/NewsletterSection';

const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://nocheydiaturismo.com';


function Home() {
  const [secciones, setSecciones] = useState([]);
  const [sections, setSections] = useState([]); 
  const [destaques, setDestaques] = useState([]); // ✅ NUEVO: Para promociones del home
  const [paquetes, setPaquetes] = useState([]);
  const [packages, setPackages] = useState([]);
  const [filteredPackages, setFilteredPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
  const fetchData = async () => {
  try {
    setLoading(true);
    console.log('Cargando datos del home...');

    // 1. Secciones
    const seccionesResponse = await fetch(`${process.env.REACT_APP_API_URL}/secciones-home`);
    if (seccionesResponse.ok) {
      const seccionesData = await seccionesResponse.json();
      setSecciones(seccionesData);
    }

    // ✅ NUEVO: Cargar destaques/promociones
    try {
      const destaquesResponse = await fetch(`${process.env.REACT_APP_API_URL}/destaques`);
      if (destaquesResponse.ok) {
        const destaquesData = await destaquesResponse.json();
        // Filtrar solo destaques que tienen paquetes
        const destaquesConPaquetes = [];
        for (const destaque of destaquesData) {
          try {
            const pkgResponse = await fetch(`${process.env.REACT_APP_API_URL}/destaques/${destaque.id}/paquetes`);
            if (pkgResponse.ok) {
              const paquetesDestaque = await pkgResponse.json();
              if (paquetesDestaque && paquetesDestaque.length > 0) {
                destaquesConPaquetes.push(destaque);
              }
            }
          } catch (err) {
            console.warn(`Error verificando destaque ${destaque.id}:`, err);
          }
        }
        setDestaques(destaquesConPaquetes);
        console.log('✅ Destaques cargados:', destaquesConPaquetes.length);
      }
    } catch (error) {
      console.warn('⚠️ Error cargando destaques:', error);
    }

    // 2. Paquetes locales
    const paquetesResponse = await fetch(`${process.env.REACT_APP_API_URL}/paquetes`);
    if (paquetesResponse.ok) {
      let paquetesData = await paquetesResponse.json();
      
      // 3. Intentar impuestos con timeout
      try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 15000);
        
        const externosResponse = await fetch(
          `${process.env.REACT_APP_API_URL}/paquetes-externos`,
          { signal: controller.signal }
        );
        clearTimeout(timeoutId);
        
        if (externosResponse.ok) {
          const externosData = await externosResponse.json();
          
          if (!externosData._fallback && externosData.estado === 1 && externosData.viajes) {
            paquetesData = paquetesData.map(pkg => {
              const externo = externosData.viajes[String(pkg.id_externo)];
              if (externo?.impuestos) {
                return { ...pkg, impuestos: parseFloat(externo.impuestos) || 0 };
              }
              return pkg;
            });
            console.log('✅ Impuestos cargados');
          }
        }
      } catch (error) {
        console.warn('⚠️ Sin impuestos externos:', error.message);
      }
      
      setPaquetes(paquetesData);
    }
  } catch (error) {
    console.error('Error:', error);
    setError('Error al cargar los datos');
  } finally {
    setLoading(false);
  }
};

  fetchData();
}, []);

  const sliderSettings = {
    dots: true, // Indicadores manuales
    infinite: false,
    speed: 500,
    slidesToShow: 3, // Máximo 3 cards visibles
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } }
    ]
  };


  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p>Cargando contenido...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Noche y Día Turismo | Inicio</title>
        <meta name="description" content="Tu agencia líder en salidas grupales." />
        <link rel="canonical" href={`${SITE_URL}/`} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${SITE_URL}/`} />
        <meta property="og:title" content="Noche y Día Turismo | Inicio" />
        <meta property="og:description" content="Tu agencia líder en salidas grupales." />
        <meta property="og:image" content={`${SITE_URL}/images/og-default.jpg`} />
        <meta property="og:site_name" content="Noche y Día Turismo" />
        <meta property="og:locale" content="es_AR" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Noche y Día Turismo | Inicio" />
        <meta name="twitter:description" content="Tu agencia líder en salidas grupales." />
        <meta name="twitter:image" content={`${SITE_URL}/images/og-default.jpg`} />
      </Helmet>
       <Header />
      
      {/* ✅ SECCIÓN MOBILE: Botón paquetes + Promociones */}
      <div className="md:hidden px-4 pt-6 pb-4 bg-gray-50 text-center">
        {/* Botón "Todos los paquetes" */}
        <button 
          onClick={() => navigate('/paquetes')}
          className="w-full bg-gradient-to-r from-[#F5A623] to-[#E09000] text-white py-4 rounded-2xl font-bold text-lg shadow-lg hover:shadow-xl transition-all flex items-center justify-center gap-2"
        >
          Todos los paquetes
        </button>
        
        {/* Promociones */}
        {destaques.length > 0 && (
          <div className="mt-5">
            <h3 className="text-lg font-bold text-gray-800 mb-3 flex items-center justify-center gap-2">
              <span>🏷️</span> Promociones
            </h3>
            
            <div className="space-y-2">
              {destaques.map((destaque) => (
                <button
                  key={destaque.id}
                  onClick={() => navigate(`/paquetes?destaque=${destaque.id}`)}
                  className="w-full text-white p-4 rounded-xl font-semibold shadow-md flex items-center gap-3 hover:shadow-lg transition-all"
                  style={{ 
                    background: `linear-gradient(135deg, ${destaque.color || '#2AA8B0'}, ${destaque.color ? destaque.color + 'CC' : '#1E3A5F'})` 
                  }}
                >
                  <span className="text-2xl">{destaque.icono || '🎯'}</span>
                  <span className="text-left flex-1">{destaque.nombre}</span>
                  <span>→</span>
                </button>
              ))}
            </div>
          </div>
        )}
      </div>

      <div className="container mx-auto px-4">
        {/* Secciones dinámicas intercaladas con banners */}
        {secciones.length > 0 && (
          <>
            {/* Sección Dinámica 1: Lo Más Vendido */}
            {secciones.find(sec => sec.id === 1) && renderSection('seccion_1') && (
              <section className="py-8 bg-white">
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-8 md:mb-10 lg:mb-12">
                  {secciones.find(sec => sec.id === 1)?.titulo || 'Lo Más Vendido'}
                </h2>
                {renderSection('seccion_1')}
                <div className="text-center mt-4">
                  <button 
                    onClick={() => navigate('/paquetes')}
                    className="bg-[#2AA8B0] text-white rounded-full px-4 py-2 mt-2 hover:bg-[#1E3A5F] transition-colors"
                  >
                    Ver más
                  </button>
                </div>
              </section>
            )}
            
            {/* Banner Estático 1: AirlinesSection */}
            <AdvertisingBanner />

            {/* Sección Dinámica 2: Paquetes Al Mejor Precio */}
            {secciones.find(sec => sec.id === 2) && renderSection('seccion_2') && (
              <section className="py-8 bg-white">
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-8 md:mb-10 lg:mb-12">
                  {secciones.find(sec => sec.id === 2)?.titulo || 'Paquetes Al Mejor Precio'}
                </h2>
                {renderSection('seccion_2')}
                <div className="text-center mt-4">
                  <button className="bg-[#2AA8B0] text-white rounded-full px-4 py-2 mt-2">Ver más</button>
                </div>
              </section>
            )}
            
            {/* Banner Estático 2: AirlinesSection */}
            <AirlinesSection />

            {/* Sección Dinámica 3: Europa 2026 */}
            {secciones.find(sec => sec.id === 3) && renderSection('seccion_3') && (
              <section className="py-8 bg-white">
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-8 md:mb-10 lg:mb-12">
                  {secciones.find(sec => sec.id === 3)?.titulo || 'Europa 2026'}
                </h2>
                {renderSection('seccion_3')}
                <div className="text-center mt-4">
                  <button className="bg-[#2AA8B0] text-white rounded-full px-4 py-2 mt-2">Ver más</button>
                </div>
              </section>
            )}
            
            {/* Banner Estático 3: InspirationSection */}
            <div className="container mx-auto px-4">
              <InspirationSection />
            </div>

            {/* Sección Dinámica 4: Ofertas Especiales */}
            {secciones.find(sec => sec.id === 4) && renderSection('seccion_4') && (
              <section className="py-8 bg-white">
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-8 md:mb-10 lg:mb-12">
                  {secciones.find(sec => sec.id === 4)?.titulo || 'Ofertas Especiales'}
                </h2>
                {renderSection('seccion_4')}
                <div className="text-center mt-4">
                  <button className="bg-[#2AA8B0] text-white rounded-full px-4 py-2 mt-2">Ver más</button>
                </div>
              </section>
            )}
            
            {/* Banner Estático 4: NewsletterSection */}
            <NewsletterSection />
          </>
        )}
        
        {/* Mensaje si no hay secciones o paquetes */}
        {secciones.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-600">No hay secciones configuradas</p>
          </div>
        )}
      </div>
      <Footer />
    </>
  );


  // Función auxiliar para renderizar secciones dinámicas
  function renderSection(sectionId) {
    // Buscar sección por ID numérico, no string
    const sec = secciones.find(s => s.id === parseInt(sectionId.replace('seccion_', '')));
    
    if (!sec) {
      console.log(`Sección ${sectionId} no encontrada`);
      return null;
    }

    // Filtrar paquetes que existen y están activos
    const paquetesSeccion = sec.paquetesIds
      ?.map(id => paquetes.find(p => p.id === id && p.estado === 'activo'))
      .filter(pkg => pkg);

    console.log(`Sección ${sectionId} - Paquetes encontrados:`, paquetesSeccion);

    if (!paquetesSeccion || paquetesSeccion.length === 0) {
      console.log(`Sección ${sectionId} no tiene paquetes activos, no se mostrará`);
      return null;
    }

return paquetesSeccion.length === 1 ? (
    <div className="flex justify-center">
      <div className="w-full max-w-sm">
        <TravelCard 
          paquete={paquetesSeccion[0]} 
          onVerDetalles={(paquete) => {
            // Navegar a paquetes con filtro específico
            const params = new URLSearchParams();
            params.set('destino', paquete.destino);
            params.set('precio_max', paquete.tarifa);
            navigate(`/paquetes?${params.toString()}`);
          }}
        />
      </div>
    </div>
  ) : (
    <Slider {...sliderSettings}>
      {paquetesSeccion.map(pkg => (
        <div key={pkg.id} className="px-2">
          <TravelCard 
            paquete={pkg}
            onVerDetalles={(paquete) => {
              // Navegar a paquetes con filtro específico
              const params = new URLSearchParams();
              params.set('destino', paquete.destino);
              params.set('precio_max', paquete.precio);
              navigate(`/paquetes?${params.toString()}`);
            }}
          />
        </div>
      ))}
    </Slider>
  );
  }
}

export default Home;